export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http') || path.startsWith('blob:') || path.startsWith('data:')) return path;
  
  const apiUrl = process.env.REACT_APP_API_URL || '';
  // Strip /api from the end of the URL if it exists, as we assume the path might contain it
  // or we just want the base domain.
  // However, the stored paths are usually /api/images/...
  // So we need the base URL without /api suffix if the stored path has /api prefix.
  
  const baseUrl = apiUrl.replace(/\/api\/?$/, '');
  return `${baseUrl}${path.startsWith('/') ? '' : '/'}${path}`;
};
